export const parseCommunityNameURI = (url, communityKey) => {
    const namespace = 'majorelle';

    if (typeof communityKey === 'string') {
        const key = encodeURI(`${namespace}."${communityKey.replace(/"/g, '')}"`);
        return `${url}${key}`
    }
    const key = encodeURI(`${communityKey.namespace}."${communityKey.name.replace(/"/g, '')}"`);
    return `${url}${key}`
};
